import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatStep, MatStepper} from '@angular/material/stepper';
import {ActivatedRoute, Router} from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {BehaviorSubject, finalize, lastValueFrom, of, Subscription, tap} from 'rxjs';
import {DocumentoProcessado} from 'src/app/api/model/conta/documents/documentos-processadosVM';
import {EntidadeService} from 'src/app/api/module/erp/services/area-logada/entidade/entidade.service';
import {ModuloPermissoesService} from 'src/app/api/module/erp/services/area-logada/modulo-permissoes/modulo-permissoes.service';
import {PropostaCotacaoService} from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import {jwtAuthService} from 'src/app/api/module/erp/services/auth/jwtAuthService';
import {
  descricaoStatusDocumento,
  DocumentStatusEnum,
} from 'src/app/api/module/erp/shared/enumerable/documento-status-enum';
import {Modulo} from 'src/app/api/module/erp/shared/enumerable/modulos';
import {PropostaExternaEnum} from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import {SubModuloNome} from 'src/app/api/module/erp/shared/enumerable/submodulos';
import {tipoAcaoEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-acao-enum';
import {TipoModalAssinaturaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-modal-assinatura';
import {
  TipoPropostaEnum,
  TipoPropostaEnumDescription,
} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import {TipoProduto_E_OperadoraComponent} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import {DocumentoUploadHelper} from 'src/app/api/module/erp/shared/helper/documento-upload-helper';
import {ListaAuxiliaresService} from 'src/app/api/module/erp/shared/lista-auxiliares/lista-auxiliares.service';
import {CompartilharDadosEntreComponentsService} from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {TabNavigationService} from 'src/app/api/module/erp/shared/services/tab-navegation/tab-navegation.service';
import {BeneficiarioPropostaSerice} from 'src/app/api/module/externo/services/proposta/beneficiario.proposta.service';
import {DocumentoPropostaEntidadeService} from 'src/app/api/module/externo/services/proposta/documento.proposta.entidade.service';
import {BlockTemplateComponent} from 'src/app/components/block-template/block-template/block-template.component';
import {ScrollService} from 'src/app/components/helper/service/scroll/scroll.service';
import {FormatarUtil} from 'src/app/pages/area-logada/shared/pipes/utils/formatadores.util';
interface Dependente {
  id: any;
  documentos: any;
}

interface ListaFinal {
  titular: any;
  dependentes: Dependente[];
}
declare var $: any;
@Component({
  selector: 'app-proposta-entidade-documentos',
  templateUrl: './proposta-entidade-documentos.component.html',
  styleUrls: ['./proposta-entidade-documentos.component.scss'],
})
export class PropostaEntidadeDocumentosComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  blockTemplate: BlockTemplateComponent | undefined;
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChildren(MatStep) steps!: QueryList<MatStep>;
  @ViewChild('modalAditivo') modalAditivo: any;
  @ViewChild('modalConfirmacaoDocumentacaoEnviada') modalConfirmacaoDocumentacaoEnviada: any;
  @ViewChild('modalFormularioInscricaoEntidade') modalFormularioInscricaoEntidade: any;
  @ViewChild('ModalConfirmacaoComponentRevisarDocumento') ModalConfirmacaoComponentRevisarDocumento: any;
  @ViewChild('modalContentVisualizarArquivosDevolvido') modalContentVisualizarArquivosDevolvido: any;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @Input() ehCorretor: boolean = false; // controla se é corretor ou não  porque vem da tela de beneficiario(Proposta interna).
  @Input() idVindoDoComponentDePropostaCorretor!: string | null;
  @Input() somenteLeituraStep: boolean = false;

  isLinear: boolean = false;
  errorMessage: boolean = false;
  formTouchedTitular: boolean = false;
  formTouchedDependente: boolean = false;
  formTouched: boolean = false;

  titleModal: string = 'Upload Document';
  modalRef?: BsModalRef;
  tipoDocumento!: number;
  activeTab: 'titular' | 'dependente' = 'titular';
  listaProfissao: any;
  nomeTitular: any;
  selectedFile: File | null = null;
  formatoArquivo: any | null = '';
  uploadStatus = '';
  _listaDocumentosTitular: any = [];
  listaDependentesTitular: any[] = []; // Lista de dependentes
  _listaDocumentosDependente: any[] = []; // Lista de documentos dos dependentes
  propostaCompleta: any[] = []; // Lista unificada de dependentes com seus documentos

  descricaoProfissaoTitular: any;
  documentoUpload: any;
  arquivoTeste: any;
  listaTipoDocumentoEnum: any;
  proposalId: any;
  holderProposalId: any;
  descricaoDocumento: any;

  documentosEnviados: {[tipoDocumento: string]: File} = {};
  documentoValido: boolean = false;
  dependentProposalId: any;
  documentoGrupo: any;
  arquivoOriginal!: File | null;
  arquivoAnterior!: File | null;
  mensagemTemporaria: any;

  spinnerMessage = '';
  visualizarArquivoUrl: any = '';
  baixarArquivo: any = '';
  nomeBotaoAcao = 'Enviar arquivo';
  acao: tipoAcaoEnum = 3;
  codigoDocumento: any;
  origem: any;
  acordeaoEstado: {[key: string]: boolean} = {};
  tituloAcaoModal: string = '';
  mensagemConfirmacao!: string;
  exibirMotivo!: boolean;
  motivoDevolucaoDocumento!: string;
  heDevolucaoDocumento: boolean = true;
  statusDocumento: any;
  _statusDocumentoEnum = DocumentStatusEnum;
  formGroupDependentes: FormGroup[] = [];
  formGroupTitular!: FormGroup;
  formSubmitted = false;
  lisaDeCarencias: any;
  textoSpinner: string = '';
  showAlertMessageTitular: boolean = false;
  showAlertMessageDependente: {[key: string]: boolean} = {};
  isFormSubmitedTitular: boolean = false;
  isFormSubmitedDependente: boolean = false;
  propostaEnum = PropostaExternaEnum;

  situacaoDocumento!: string;
  listaRetornoEnvio: any[] = [];
  existeDocumentoComPendencia: any[] = [];
  mensagemListaRetornoDM: any;
  exibirMensagemAvisoDependente: boolean = false;
  stepAtual!: number;
  exibir: boolean = false;
  dadosCompartilhadoDM: any;
  mostrarModalAditivo: any;
  codigoProposta: any;
  entidadeProposta: any;
  private subscription!: Subscription;
  private modalAberto: boolean = false;
  ehImagem: boolean = false;
  zoom = 0.8;
  rotation = 0;
  nomeTipoDocumento: any;
  naturalWidth = 0;
  naturalHeight = 0;
  modalAditivoRef?: BsModalRef;
  modalConfirmacaoDocumentacaoEnviadaRef!: BsModalRef;
  listaDeBeneficiarios = new Array<any>();
  nomeModalAditivo: any;
  informacoesDocumentoVisualizarMap: Map<string, any[]> = new Map();

  documentoFiltradoModal: any;
  objectKeys = Object.keys;
  checkboxModalAditivo: boolean = false;
  idBeneficiarioDoModalAditivo: string = '';
  objModalAditivo: any;
  razaoSocialEntidade: string = '';
  logoEntidade: string = '';
  nomeEntidade: string = '';
  inclusaoDependente: boolean = false;
  nomeProduto: any;
  mostrarAbaDependente: boolean = true;
  mensagemModal: any;
  mensagemRetornoDocumentoOK: string = '';
  listaFinalFormulario: ListaFinal = {
    titular: [],
    dependentes: [],
  };
  heOdonto!: boolean;
  retornoDadosFormularioEntidade!: null;
  existeFormularioEntidade: boolean = false;
  modalInscricaoEntidadeRef?: BsModalRef;
  modalRevisarDocumentoRef?: BsModalRef;
  linkExternoEntidade: any;
  heAssociado: any;
  dadosOperadoraCabecalho: any;
  operadoraVM: any;
  dataAssinaturaFormInscricao: string = '';
  horaAssinaturaFormInscricao: string = '';
  tipoPropostaTitular: any;
  formDependenteAlterado: boolean = false;
  // Mapa para controlar pendências específicas por dependente
  pendenciasPorDependente: Map<string, boolean> = new Map();
  pendenciaFormTitular: boolean = false;
  dadosCarregados: boolean = false;
  private acordeaoAtivo: {tipo: 'titular' | 'dependente'; index?: number; dependente?: any} | null = null;
  idTitularImutavel: '';

  scrollPosition: number = 0;
  maxScroll: number = 0;
  listaDocuemntosProcessadosReprovados: DocumentoProcessado[];
  mostrarBotaoDevolver: boolean = true;
  documentoEmTela: any = null;
  mostrarBotaoAprovarDocumento: any;
  ocultarBtnAcaoVisualizar: boolean = false;
  mostrarUploadDocumentoColaborador: boolean = false;

  constructor(
    private bsLocaleService: BsLocaleService,
    private _listaAux: ListaAuxiliaresService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private documentoUploadHelper: DocumentoUploadHelper,
    private documentoPropostaEntidadeService: DocumentoPropostaEntidadeService,
    private _propostaCotacaoService: PropostaCotacaoService,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
    private _activeRoute: ActivatedRoute,
    private _router: Router,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private jwtAuthService: jwtAuthService,
    private tabService: TabNavigationService,
    private _spinnerService: SpinnerService,
    private _errorLoggingService: ErrorLoggingService,
    private _beneficiarioProposaService: BeneficiarioPropostaSerice,
    private _scrollService: ScrollService,
    private _entidadeService: EntidadeService,
    private moduloPermissoesService: ModuloPermissoesService,
  ) {
    this.bsLocaleService.use('pt-br');
  }

  public get heColaborador(): boolean {
    return this._router.url.includes('colaborador');
  }

  ngOnDestroy(): void {}
  async ngAfterViewInit(): Promise<void> {
    try {
      await this.receberDadosCompartilhadoBeneficiario();

      if (!this.ehCorretor) {
        await this.usuarioLogado();
      }
    } catch (error) {
    } finally {
      this.pararSpinner();
    }
  }
  async ngOnInit(): Promise<void> {
    this.criarFormTitular();
    this.buscarProfissao();
    this.listaCarencias();
    this.listarTiposDocumentoEnum();
    await this.buscarDadosDaProposta();
    this.dispararModalAditivo();
    this.operadoraVM = this.carregarDadosOperadora();
    await this.verificarStatusDocumentosPorProposta();
  }

  async ngOnChanges(changes: SimpleChanges) {
    // Verifica se o idVindoDoComponentDePropostaCorretor mudou e se é diferente do valor anterior
    // e se existe um idVindoDoComponentDePropostaCorretor
    if (
      changes['idVindoDoComponentDePropostaCorretor'] &&
      changes['idVindoDoComponentDePropostaCorretor'].currentValue !==
        changes['idVindoDoComponentDePropostaCorretor'].previousValue &&
      this.idVindoDoComponentDePropostaCorretor
    ) {
      await this.buscarDadosDaProposta(this.idVindoDoComponentDePropostaCorretor);
    }
    await this.buscarDadosDaProposta();
  }

  async dispararModalAditivo() {
    try {
      if (!this.heColaborador && !this.ehCorretor) {
        this.tabService.documentosAtivada$.subscribe(async () => {
          if (!this.heColaborador && !this.modalAberto) {
            await this.abrirModalAditivo();
          }
        });
      }
    } catch (error) {
      this._errorLoggingService.logError('Erro ao disparar modal aditivo', error, {
        contexto: 'dispararModalAditivo',
      });
    } finally {
      this.pararSpinner();
    }
  }

  async usuarioLogado(): Promise<void> {
    const currentUrl = this._router.url;
    const isLogado = this.jwtAuthService.isUsuarioLogado();
    const idProposta = await this.obterIdPropostaDaRota();
    this.proposalId = idProposta;
    const token = localStorage.getItem('token');

    const isDev = !currentUrl.includes('desenv-proposta'); // Verifica se a URL contém 'desenv-proposta'usado somente localmente
    const caminhoUrl = isDev ? '/proposta' : 'desenv-proposta/proposta';

    if (this.heColaborador) {
      // Se for colaborador, verifica se está logado antes de redirecionar
      if (!isLogado) {
        this._router.navigate(['/login']);
        return;
      }

      //desenv-proposta/proposta/colaborador/..... ou //proposta/colaborador/.....
      this._router.navigate([`${caminhoUrl}/colaborador/${this.proposalId}`]);
    } else {
      //desenv-proposta/proposta/beneficiario/..... ou //proposta/beneficiario/.....
      this._router.navigate([`${caminhoUrl}/beneficiario/${this.proposalId}`]);
    }

    // Caso o usuário não seja colaborador e a URL contenha "detalhes/proposta"
    if (!this.heColaborador && currentUrl.includes('detalhes/proposta')) {
      this._router.navigate([`/detalhes/proposta/${this.proposalId}`]);

      return;
    }
  }

  criarFormularioDependente(dependentes: any[]) {
    this.formGroupDependentes = [];
    if (this.heColaborador) {
      this.listaFinalFormulario.dependentes = [];
    }
    dependentes.forEach(dependente => {
      const formGroup = this.formBuilder.group({
        id: [dependente.id],
        idLife: [dependente.id], // ID do dependente
        holder: [false],
        neediness: [dependente?.neediness || null, Validators.required],
        otherPendingIssues: [dependente?.otherPendingIssues || false],
        noteSupport: [dependente?.noteSupport || null],
        dependenteName: [dependente.name || null],
      });

      if (this.heColaborador) {
        this.listaFinalFormulario.dependentes.push(formGroup.value as any);
      }

      this.formGroupDependentes.push(formGroup);
      // Sincronizar pendência com o valor atual do formulário do dependente
      if (formGroup.controls['otherPendingIssues'].value) {
        this.marcarPendenciaFormDependente(formGroup.controls['dependenteName'].value);
      } else {
        this.pendenciasPorDependente.delete(formGroup.controls['dependenteName'].value.toLowerCase());
      }

      if (!formGroup.controls['neediness'].value) {
        this.marcarPendenciaFormDependente(formGroup.controls['dependenteName'].value);
      } else {
        this.pendenciasPorDependente.delete(formGroup.controls['dependenteName'].value.toLowerCase());
      }
    });
  }

  isFormTitularValid() {
    this.isFormSubmitedTitular = true;
    return this.formGroupTitular.valid;
  }

  validarFormDependente() {
    this.formGroupDependentes.forEach(formGroup => {
      if (formGroup.invalid) {
        this.marcarControlesComoTouched(formGroup);
      }
    });
    const algumFormInvalido = this.formGroupDependentes.findIndex(formGroup => formGroup.invalid);

    const nomeDependenteFormInvalido = algumFormInvalido !== -1 ? this.propostaCompleta[algumFormInvalido]?.name : null;

    if (algumFormInvalido !== -1) {
      this.toastr.warning(`Preencha todos os campos obrigatórios do dependente ${nomeDependenteFormInvalido}!`);
      this.marcarPendenciaFormDependente(nomeDependenteFormInvalido);
      this.formGroupDependentes.forEach(formGroup => {
        if (formGroup.invalid) {
          this.marcarControlesComoTouched(formGroup);
        }
      });
      return;
    }
  }

  marcarControlesComoTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.marcarControlesComoTouched(control);
      }
    });
  }
  verificarErrosDependentes() {
    this.formGroupDependentes.forEach((formGroup, index) => {
      if (formGroup.invalid) {
      }
    });
  }
  onFieldChange(dependenteId?: string, nomeDependente?: any) {
    this.formTouchedTitular = true;
    this.formTouchedDependente = true;
    const FormGroupTitular = this.formGroupTitular;
    this.showAlertMessageTitular = !this.isFormTitularValid();
    // Se um dependenteId foi passado, atualiza o estado apenas para esse dependente
    if (dependenteId) {
      const formGroupDependente = this.formGroupDependentes.find(fg => fg.value.idLife === dependenteId);

      if (formGroupDependente) {
        this.showAlertMessageDependente[dependenteId] = true;
        const campoObservaoApoio = formGroupDependente.get('noteSupport')?.value;
        // Verificar se noteSupport tem valor para remover pendência

        if (formGroupDependente.get('otherPendingIssues')?.value === true && !campoObservaoApoio) {
          this.marcarPendenciaFormDependente(formGroupDependente.controls['dependenteName']?.value);
        } else {
          this.pendenciasPorDependente.delete(formGroupDependente.controls['dependenteName']?.value?.toLowerCase());
        }
      }
    } else {
      // 1. Se otherPendingIssues == true existe pendência
      if (FormGroupTitular.get('otherPendingIssues')?.value === true && !FormGroupTitular.get('noteSupport')?.value) {
        this.pendenciaFormTitular = true;
      } else this.pendenciaFormTitular = false;
    }

    this.cdRef.detectChanges();
    this.cdRef.markForCheck();
  }

  criarFormTitular() {
    this.formGroupTitular = this.formBuilder.group({
      idLife: [null],
      holder: [true],
      defaultWithAdmServ: [false],
      neediness: [null, Validators.required],
      otherPendingIssues: [false],
      noteSupport: [null],
    });
    this.formGroupTitular.controls['neediness'].valueChanges.subscribe((value: any) => {
      if (value) this.pendenciaFormTitular = false;
      else this.pendenciaFormTitular = true;
    });
    this.formGroupTitular.controls['otherPendingIssues'].valueChanges.subscribe((value: any) => {
      if (value) this.pendenciaFormTitular = true;
      else this.pendenciaFormTitular = false;
    });
  }

  abrirModal(
    templateModalUpload: TemplateRef<any>,
    tipoDocumento: any,
    origem: any,
    descricaoDocumento: string,
    documentProposalId: string,
    filePath: any,
    documentoGrupo: number,
    idOrigem: number,
    dataUrl: string,
    motivoReprovacao: string,
    statusDocumento: string,
  ) {
    this.motivoDevolucaoDocumento = motivoReprovacao;
    this.situacaoDocumento = statusDocumento;
    this.iniciarSpinner();
    this.mensagemTemporaria = '';
    this.descricaoDocumento = descricaoDocumento;
    this.tipoDocumento = tipoDocumento;
    this.documentoGrupo = documentoGrupo;
    this.codigoDocumento = documentProposalId;
    this.origem = origem;
    this.visualizarArquivoUrl = '';
    this.baixarArquivo = '';
    if (origem == 'titular') this.holderProposalId = idOrigem;
    else this.dependentProposalId = idOrigem;
    // Verifica se o dataUrl existe (ajustei para usar somente dataUrl aqui, pois arquivo é obtido dele)
    if (dataUrl) {
      try {
        // Obtém informações sobre o arquivo a partir da URL
        let arquivo = this.documentoUploadHelper.getFileInfoFromUrl(dataUrl);
        this.visualizarArquivoUrl = filePath;
        this.baixarArquivo = dataUrl;

        // Decodifica o arquivo da URL para um objeto `File`
        const arquivoDecodificado = this.documentoUploadHelper.dataURLtoFile(dataUrl, arquivo.name, arquivo.format);

        this.arquivoOriginal = arquivoDecodificado;
        this.selectedFile = arquivoDecodificado;
        this.modalRef = this.modalService.show(templateModalUpload, {
          class: 'modal-xl',
        });
        this.cdRef.detectChanges();

        setTimeout(() => {
          const inputDocumentoUpload = document.getElementById('inputDocumentoUpload') as HTMLInputElement;

          if (inputDocumentoUpload) {
            // Tenta usar DataTransfer API (pode não funcionar no Safari)
            try {
              const dataTransfer = new DataTransfer();
              dataTransfer.items.add(arquivoDecodificado);
              inputDocumentoUpload.files = dataTransfer.files;
            } catch (error) {
              // Alternativa para Safari e outros navegadores com restrições
              console.warn('DataTransfer API não suportada, usando alternativa para Safari:', error);
              // Armazena o arquivo para uso posterior sem tentar atribuir ao input
              this.selectedFile = arquivoDecodificado;
              this.arquivoOriginal = arquivoDecodificado;
            }
          }
          this.pararSpinner(1000);
        }, 0);
      } catch (error) {
        this.toastr.error('Erro ao processar arquivo.');
        this.pararSpinner();
      }
    } else {
      this.modalRef = this.modalService.show(templateModalUpload, {
        class: 'modal-xl',
      });
      this.pararSpinner(1000);
    }

    if (documentProposalId) {
      this.acao = tipoAcaoEnum.EDICAO;
      this.nomeBotaoAcao = 'Atualizar Arquivo';
    } else {
      this.acao = tipoAcaoEnum.CADASTRO;
      this.nomeBotaoAcao = 'Enviar Arquivo';
    }
  }

  fecharModal() {
    this.modalService.hide();
  }

  fecharModalAviso() {
    this.tratativaRedirecionamentoAbas(this.mensagemRetornoDocumentoOK);
    this.modalConfirmacaoDocumentacaoEnviadaRef.hide();
  }

  async uploadDocumento(event?: Event) {
    // Guarda o arquivo original antes de abrir o seletor
    this.arquivoAnterior = this.arquivoOriginal || null;
    this.baixarArquivo = '';
    if (event) {
      // Se veio do input, chama diretamente a função de seleção
      this.onSelecionarArquivo(event);
    } else {
      // Caso contrário, cria um input dinamicamente
      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.accept = '.doc, .docx, .pdf, image/*';
      inputElement.addEventListener('change', async (event: Event) => {
        await this.onSelecionarArquivo(event);
      });
      inputElement.click();
    }
  }

  abrirInputDocumento() {
    this.baixarArquivo = '';
    // Obtém o elemento de input pelo id e dispara o clique nele.
    const inputElement = document.getElementById('inputDocumentoUpload') as HTMLInputElement;
    if (inputElement) {
      inputElement.click();
    }
  }

  onSelecionarArquivo(event: Event) {
    this.iniciarSpinner();
    const inputElement = event.target as HTMLInputElement;

    if (!inputElement.files || inputElement.files.length === 0) {
      this.restaurarArquivoNoInput();
      this.pararSpinner();
      return;
    }

    const file = inputElement.files[0];
    this.arquivoOriginal = file;
    const fileName = file.name.toLowerCase();

    const tamanhoArquivo = file.size / (1024 * 1024);
    const tamanhoArquivoAceite = 5; // 5MB
    const extensoesPermitidas = ['.doc', '.docx', '.pdf', '.jpg', '.jpeg', '.png'];

    const heFormatoValido = extensoesPermitidas.some(ext => fileName.endsWith(ext));

    if (tamanhoArquivo > tamanhoArquivoAceite) {
      inputElement.value = '';
      this.mensagemTemporaria = 'Arquivo grande para Upload. Tamanho máximo: 5 MB.';
      this.toastr.warning('Tamanho máximo para Upload: 5 MB.');
      this.pararSpinner();
      return;
    }

    if (!heFormatoValido) {
      inputElement.value = '';
      this.toastr.warning('Formato de arquivo inválido! Apenas arquivos .pdf, .jpg, .jpeg e .png são permitidos.');
      this.mensagemTemporaria = 'Formato de arquivo inválido! Apenas arquivos .pdf, .jpg, .jpeg e .png são permitidos.';
      this.pararSpinner();
      return;
    }

    const reader = new FileReader();

    reader.onload = e => {
      const tipoDocumento = this.tipoDocumento;

      this.validarDocumentoUpload(tipoDocumento, this.arquivoOriginal).subscribe({
        next: (isValid: boolean) => {
          if (this.documentoValido) {
            const itemData = e.target?.result as string | ArrayBuffer;
            const format = this.documentoUploadHelper.getFileFormatFromFileName(file.name);

            const retornoDocumentoUpload = this.adicionarDocumento(itemData, format, file);

            this.visualizarArquivoUrl = null;
            const pdfUrl = this.documentoUploadHelper.visualizarPDFUrl(retornoDocumentoUpload.dataUrl);
            this.visualizarArquivoUrl = pdfUrl;

            if (!this.documentosEnviados) this.documentosEnviados = {};
            this.documentosEnviados[this.tipoDocumento] = retornoDocumentoUpload;

            this.selectedFile = file;
            this.uploadStatus = 'Upload concluído com sucesso!';
          }
          this.pararSpinner();
        },
        error: err => {
          this.toastr.error('Erro ao validar o documento.');
          this.pararSpinner();
        },
      });
    };

    reader.readAsDataURL(file);
  }

  restaurarArquivoNoInput() {
    setTimeout(() => {
      const inputDocumentoUpload = document.getElementById('inputDocumentoUpload') as HTMLInputElement;

      if (inputDocumentoUpload && this.arquivoAnterior) {
        try {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(this.arquivoAnterior);
          inputDocumentoUpload.files = dataTransfer.files;
        } catch (error) {
          console.warn('DataTransfer API não suportada no método restaurarArquivoNoInput:', error);
          // Para Safari, apenas garante que o arquivo esteja armazenado
          this.selectedFile = this.arquivoAnterior;
          this.arquivoOriginal = this.arquivoAnterior;
        }
      }
    }, 0);
  }

  validarDocumentoUpload(tipoDocumento: number, arquivo: any) {
    this.iniciarSpinner();
    const subject = new BehaviorSubject<boolean>(false);
    this.toastr.toastrConfig.preventDuplicates = true;
    this.documentoPropostaEntidadeService.validadeDocumento(tipoDocumento, arquivo).subscribe({
      next: async (data: any) => {
        this.documentoValido = true;
        this.mensagemTemporaria = '';
        this.toastr.success(data.data);
        subject.next(true);
      },
      error: async err => {
        this.documentoValido = false;
        this.mensagemTemporaria = err.message;
        this.toastr.warning(err.message || 'Erro ao validar arquivo.');
        return subject.next(false);
      },
    });
    return subject.asObservable();
  }

  adicionarDocumento(itemData: string | ArrayBuffer, format: string | null, file: File): any {
    const document: any = {
      dataUrl: itemData,
      format: format,
      fileName: file.name,
      file: file,
      size: file.size,
      visualizarDocumento: false,
      status: 'PENDENTE',
    };

    if (document.format == 'pdf') {
      document.visualizarDocumento = true;
    }
    return (this.documentoUpload = document);
  }

  downloadDocumento(index: number) {
    this.documentoUploadHelper.downloadDocument(index, []);
  }

  nomeArquivo(name: string): any {
    return this.documentoUploadHelper.getNameFile(name);
  }

  enviarArquivoUploaded() {
    this.iniciarSpinner();
    const documentoVM = this.criarDocumentoVM();

    if (!this.arquivoOriginal) {
      this.toastr.warning('Nenhum documento carregado!');
      return;
    }

    this.enviarDocumento(documentoVM);
  }

  criarDocumentoVM() {
    return {
      proposalId: this.proposalId,
      holderProposalId: this.origem == 'titular' ? this.holderProposalId : null,
      documentType: this.tipoDocumento,
      dependentProposalId: this.origem == 'dependente' ? this.dependentProposalId : null,
      groupDocument: this.documentoGrupo,
      description: '....',
      documentProposalId: this.codigoDocumento,
    };
  }

  enviarDocumento(documentoVM: any) {
    this.iniciarSpinner();
    const isEdicao = this.acao === tipoAcaoEnum.EDICAO;
    const request$ = isEdicao
      ? this.documentoPropostaEntidadeService.atualizarDocumento(documentoVM.documentProposalId, this.arquivoOriginal)
      : this.documentoPropostaEntidadeService.enviarDocumentos(documentoVM, this.arquivoOriginal);

    request$.subscribe({
      next: () => {
        try {
          this.mensagemSucesso(isEdicao);

          if (this.origem === 'titular' && this.holderProposalId) {
            this.buscarDocumentosTitular();
          } else {
            this.recarregarDocumentosDependente();
          }
        } catch (err) {
          this.toastr.error('Erro ao fazer upload do documento.');
          this._errorLoggingService.logError('Erro ao fazer upload do documento', err, {
            idProposta: this.proposalId,
            titular: this.holderProposalId,
          });
          this.pararSpinner();
        } finally {
          this.pararSpinner();
        }
      },
      error: err => {
        this.mensagemErro(err);
        this.pararSpinner();
      },
    });
  }

  private async recarregarDocumentosDependente() {
    const documentos = await this.buscarTodosOsDependentesDoTitular(this.dependentProposalId);
    // Encontra o dependente na lista propostaCompleta
    const dependenteIndex = this.propostaCompleta.findIndex(d => d.id === this.dependentProposalId);
    if (dependenteIndex !== -1) {
      // Atualiza a lista de documentos do dependente
      this.propostaCompleta[dependenteIndex].documentos = documentos;
    }

    // Mantém o acordeão aberto
    this.acordeaoEstado[this.dependentProposalId] = true;
  }

  mensagemErro(err: any) {
    this.pararSpinner();
    this.documentoValido = false;
    this.mensagemTemporaria = err.message;
    this.toastr.warning(err.message || 'Erro ao processar o documento.');
  }

  finalizar() {
    this.toastr.success('Enviados...');
  }

  buscarProfissao() {
    this._listaAux.listaProfissao().subscribe(data => {
      this.listaProfissao = data && data;
    });
  }
  listaCarencias() {
    this._listaAux.listaCarencias().subscribe(data => {
      this.lisaDeCarencias = data && data;
    });
  }

  receberDadosCompartilhadoBeneficiario(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._compartilharDadosEntreComponentsService.obterDadosCompartilhados().subscribe(
        data => {
          this.dadosCompartilhadoDM = data;
          if (data && Array.isArray(data) && data.length > 0 && data[0]?.dadosBeneficiario) {
            this.nomeTitular = data && data[0]?.dadosBeneficiario.holderProposal?.name;
            this.descricaoProfissaoTitular = this.listaProfissao?.filter(
              (x: any) => x.id == data[0].dadosBeneficiario.holderProposal.professionId,
            )[0]?.name;
          } else {
            return;
          }
        },
        error => {
          this._errorLoggingService.logError('Erro ao receber dados compartilhados do beneficiário', error, {
            contexto: 'Compartilhamento de dados entre componentes',
          });
          reject(error);
        },
      );
    });
  }

  arquivoBlobDownload() {
    this.iniciarSpinner();
    if (this.baixarArquivo) {
      if (typeof this.baixarArquivo === 'string') {
        window.open(this.baixarArquivo, '_blank');
      }
    }
    this.pararSpinner(1000);
  }

  // Método auxiliar para detectar Safari
  private isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  // Método auxiliar para detectar imagens com compatibilidade Safari
  private detectarImagem(url: string): boolean {
    if (!url) return false;

    try {
      // Para Safari, usa uma abordagem mais robusta
      if (this.isSafari()) {
        return (
          url.startsWith('data:image/') ||
          url.toLowerCase().includes('.jpg') ||
          url.toLowerCase().includes('.jpeg') ||
          url.toLowerCase().includes('.png') ||
          url.toLowerCase().includes('.gif')
        );
      }

      // Para outros navegadores, usa o método original
      return this.documentoUploadHelper._ehImagemUrl(url);
    } catch (error) {
      console.warn('Erro ao detectar imagem:', error);
      return false;
    }
  }

  abrirModalVisualizarDocumento(
    template: TemplateRef<any>,
    filePath?: any,
    codigoDocumento?: any,
    origem?: string,
    idOrigem?: string,
    statusDocumento?: any,
    documentoDM?: any,
    visualizarInputUploadBeneficiario?: boolean,
    tipoDocumento?: any,
    documentoGrupo?: any,
    tabelaDevolucao?: any,
  ) {
    this.iniciarSpinner();
    of(true)
      .pipe(
        tap(() => {
          if (!visualizarInputUploadBeneficiario) {
            this.visualizarArquivoUrl = '';
            this.ehImagem = false;
          }

          this.mostrarUploadDocumentoColaborador = statusDocumento == DocumentStatusEnum.CORRECAO ? true : false;

          if (this.mostrarUploadDocumentoColaborador) this.acao = tipoAcaoEnum.EDICAO;

          this.ocultarBtnAcaoVisualizar = tabelaDevolucao ? true : false;

          // if (!filePath && !documentoDM?.dataUrl && !this.visualizarArquivoUrl) {
          //   this.visualizarArquivoUrl = '';
          //   this.toastr.warning('Nenhum documento para visualizar.');
          //   return;
          // }
          this.mostrarBotaoAprovarDocumento = statusDocumento == DocumentStatusEnum.OK;
          if (tipoDocumento) this.tipoDocumento = tipoDocumento;
          if (documentoGrupo) this.documentoGrupo = documentoGrupo;

          // Detecta imagem
          if (documentoDM?.dataUrl && this.detectarImagem(documentoDM.dataUrl)) {
            this.visualizarArquivoUrl = documentoDM.dataUrl;
            this.ehImagem = true;
          } else if (filePath && this.detectarImagem(filePath)) {
            this.visualizarArquivoUrl = filePath;
            this.ehImagem = true;
          } else if (filePath) {
            this.visualizarArquivoUrl = filePath;
            this.ehImagem = false;
          } else if (visualizarInputUploadBeneficiario && this.detectarImagem(this.baixarArquivo)) {
            this.visualizarArquivoUrl = this.baixarArquivo;
            this.ehImagem = true;
          } else {
            this.ehImagem = false;
          }

          this.codigoDocumento = codigoDocumento || '';
          if (origem) {
            this.origem = '';
            this.origem = origem;

            if (origem === 'titular') {
              this.dependentProposalId = '';
              this.holderProposalId = idOrigem;
            } else if (origem === 'dependente') {
              this.holderProposalId = '';
              this.dependentProposalId = idOrigem;
            }
          }

          this.nomeTipoDocumento = documentoDM?.documentType;
          this.filtrarDocumentosRelacionados(documentoDM);

          this.modalRef = this.modalService.show(template, {
            class: 'modal-xl',
            id: 'visualizarDocumento',
          });
        }),
        finalize(() => {
          this.pararSpinner(2000);
        }),
      )
      .subscribe({
        error: (error: any) => {
          this._errorLoggingService.logError('Falha ao buscar dados da proposta', error, {
            contexto: 'Cadastro de proposta Interna',
            dadosEnviados: {
              ...(filePath && {filePath}),
              codigoDocumento,
              origem,
              idOrigem,
              statusDocumento,
              documentoDM,
            },
          });

          this.toastr.error('Erro ao abrir visualização do documento');
        },
      });
  }

  filtrarDocumentosRelacionados(documentoDM: any): void {
    this.documentoEmTela = null;
    this.mostrarBotaoDevolver = documentoDM.documentStatusEnum != DocumentStatusEnum.CORRECAO ? true : false;
    if (documentoDM) {
      this.documentoEmTela = documentoDM;
    }

    const docTitle = documentoDM?.documentTitle ?? documentoDM?.title;
    if (!documentoDM?.documentType && !docTitle) {
      this.documentoFiltradoModal = null;
      return;
    }
    // Determina a chave correta pela origem atual
    const id = this.origem === 'titular' ? this.holderProposalId : this.dependentProposalId;

    const chave = `${this.origem}_${id ?? 'sem-id'}`;
    const documentosDestaOrigem = this.informacoesDocumentoVisualizarMap.get(chave) ?? [];

    const documentosFiltrados = documentosDestaOrigem.filter(
      (doc: any) => doc.documentType === documentoDM?.documentType || doc.documentTitle === docTitle,
    );

    this.documentoFiltradoModal = {
      documentType: documentoDM?.documentType,
      documentTitle: docTitle,
      totalDocumentos: documentosFiltrados.length,
      documentos: documentosFiltrados.map((doc: any) => ({
        groupTitle: doc.groupTitle,
        documentStatus: doc.documentStatus,
        extraData: doc.extraData,
        documentType: doc.documentType,
        documentTitle: doc.documentTitle,
      })),
    };
  }
  fecharModalVisualizar() {
    this.modalService.hide('visualizarDocumento');
  }

  listarTiposDocumentoEnum() {
    try {
      this._listaAux.listarTiposDocumento().subscribe(data => {
        this.listaTipoDocumentoEnum = data && data;
      });
    } catch (error) {
      this._errorLoggingService.logError('Listar Tipo documentos Enums', error, {
        contexto: 'Erro ao listar os tipos de Documentos Enum',
      });
    }
  }

  private obterIdPropostaDaRota(): any {
    let propostaId = '';
    if (this.ehCorretor && this.idVindoDoComponentDePropostaCorretor) {
      propostaId = this.idVindoDoComponentDePropostaCorretor;
    } else {
      this.idVindoDoComponentDePropostaCorretor = '';
      // Se não for corretor, obtém o idProposta da rota ativa
      propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
    }
    return propostaId;
  }

  // Responsável por buscar os ados da proposta.
  async buscarDadosDaProposta(propostaId?: string) {
    try {
      this.iniciarSpinner();
      const idProposta = this.obterIdPropostaDaRota();
      if (!idProposta) return;
      if (idProposta) {
        const data = await lastValueFrom(this._propostaCotacaoService.buscarDadosPropostaPorId(idProposta));
        this.logoEntidade = data.branchCompanyNameLogo;
        this.razaoSocialEntidade = data.branchCompanySocialReason;
        this.nomeEntidade = data.branchCompanyName;
        this.nomeProduto = data?.productName;
        this.mostrarModalAditivo = data?.proposalType;
        this.codigoProposta = data?.code;
        this.entidadeProposta = data?.branchCompanyName;
        this.stepAtual = data && data?.step;
        this.proposalId = data?.id;
        this.idTitularImutavel = data?.holderProposal?.id;
        this.holderProposalId = data?.holderProposal?.id;
        this.tipoPropostaTitular = data?.proposalTypeName;
        this.listaDependentesTitular = [];
        this.listaDependentesTitular = data?.holderProposal?.dependentsProposal || [];
        this.inclusaoDependente = data?.dependentInclusion;
        this.heOdonto = TipoProduto_E_OperadoraComponent.isOdonto(data?.productType);
        this.linkExternoEntidade = data?.externalRegistrationLink;
        this.heAssociado = data?.holderProposal?.isAssociate;
        let heUdemo = false;
        if (data?.branchCompanyName?.toLowerCase() == 'udemo') {
          heUdemo = true;
        }
        this.preencherAssinaturas(data?.dealLeads);
        this.preencherDadosCabecalhoDocumento(data, heUdemo);
        if (this.inclusaoDependente) {
          this.activeTab = 'dependente';
          this.stepper.selectedIndex = 0;
          this.buscarTodosOsDependentesDoTitular();
        } else {
          this.activeTab = 'titular';
          await this.buscarDocumentosTitular();
        }
        this.mostrarAbaDependente = this.listaDependentesTitular?.length > 0 ? true : false;
        this.propostaCompleta =
          this.listaDependentesTitular?.length > 0
            ? this.listaDependentesTitular.map(dependente => ({
                ...dependente,
                documentos: [],
              }))
            : [];
        // Cria os formulários para cada dependente
        this.criarFormularioDependente(this.propostaCompleta);

        this.separarBeneficiarios(data);

        if (!this.heColaborador && !this.ehCorretor && data.step == PropostaExternaEnum.DOCUMENTO)
          this.abrirModalAditivo();
      }
    } catch (error) {
      //  Log detalhado no Sentry
      this._errorLoggingService.logError('Erro ao buscar dados da proposta', error, {
        idProposta: propostaId || this.proposalId,
      });
    } finally {
      this.pararSpinner();
    }
  }

  private preencherDadosCabecalhoDocumento(data: any, heUdemo: boolean) {
    this.dadosOperadoraCabecalho = {
      nomeOperadora: data.operatorName,
      ansRegister: data.operatorAnsRegister,
      site: data.operatorSite,
      cnpjOperadora: data.operatorCNPJ,
      contatoOPeradora: data.operatorNumber,
      tipoProduto: data?.productType,
      ehInclusaoDependente: data?.dependentInclusion,
      logoOperadora: data?.operatorURLImage,
      dadosEntidade: {
        heUdemo: heUdemo,
        nomeEntidade: data?.branchCompanyName,
        logoEntidade: data.branchCompanyNameLogo,
      },
    };
  }

  async filtrarDocumentoPorIdDependente(dependentProposalId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.documentoPropostaEntidadeService
        .buscarDocumentoDependentePropostaId(dependentProposalId, this.proposalId)
        .subscribe({
          next: (data: any) => {
            if (!data || !data.documents || data.documents.length === 0) {
              this.toastr.warning('Não foi localizado nenhum documento para este dependente!');
              this.exibirMensagemAvisoDependente = true;
            } else {
              this.exibirMensagemAvisoDependente = false;
              this._listaDocumentosDependente = data;
              this.montarObjLeituraDocumento(data, 'dependente', dependentProposalId);
            }

            // Sempre resolve, mesmo com lista vazia
            resolve(data);
          },
          error: err => {
            const mensagemTratada = err.message?.replace('Error:', '') || '';
            if (mensagemTratada.includes('[object Object]')) {
              this.toastr.warning('Nenhum documento localizado!');
            } else {
              this.toastr.warning(mensagemTratada || 'Erro desconhecido');
            }
            this._errorLoggingService.logError('Erro ao filtrar documentos por ID do dependente', err, {
              contexto: 'Filtrar documentos dependente',
              dependentProposalId,
              proposalId: this.proposalId,
            });
            reject(err);
          },
        });
    });
  }

  async abrirDetalhesDependente(dependente: any) {
    try {
      // Verifica o estado atual do acordeão antes de alternar
      const estavaAberto = this.acordeaoEstado[dependente.id];
      // Alterna o estado do acordeão
      this.alternarAcordeao(dependente.id);

      // Só chama o backend se o acordeão estava fechado e agora está sendo aberto
      if (!estavaAberto && this.acordeaoEstado[dependente.id]) {
        //   Registra o dependente clicado como ativo
        const index = this.propostaCompleta.findIndex((d: any) => d.id === dependente.id);
        this.acordeaoAtivo = {tipo: 'dependente', index, dependente};
        this.iniciarSpinner();
        const documentos = (await this.filtrarDocumentoPorIdDependente(dependente.id)) as any;

        const dependenteIndex = this.propostaCompleta.findIndex(d => d.id === dependente.id);

        if (dependenteIndex !== -1) {
          if (documentos.documents.length > 0) {
            this.exibirMensagemAvisoDependente = false;
          } else {
            this.exibirMensagemAvisoDependente = true;
          }
          this.propostaCompleta[dependenteIndex].documentos = documentos;
          if (!this.formDependenteAlterado) {
            this.alimentarFormDependente(dependenteIndex, dependente.id);
          } else {
            this.preencherDados(false, dependenteIndex);
          }
        }

        this.pararSpinner();
      } else if (estavaAberto) {
        //  Fechou o acordeon manualmente
        this.acordeaoAtivo = null;
      }
    } catch (error) {
      this._errorLoggingService.logError('Erro ao abrir detalhes do dependente', error, {
        contexto: 'Abrir detalhes dependente',
        dependenteId: dependente.id,
        propostaId: this.proposalId,
      });
      this.pararSpinner();
    }
  }

  async buscarTodosOsDependentesDoTitular(dependentProposalId?: any): Promise<any[]> {
    this.iniciarSpinner();
    try {
      const idPropostaAlternativa = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
      const idProposta = await this.obterIdPropostaDaRota();
      this.proposalId = idProposta || idPropostaAlternativa;
      // Caso: buscar todos os dependentes
      if (!dependentProposalId) {
        const resultados = await Promise.all(
          (this.propostaCompleta || []).map(async dependente => {
            try {
              const data = await lastValueFrom(
                this.documentoPropostaEntidadeService.buscarDocumentoDependentePropostaId(
                  dependente.id,
                  this.proposalId,
                ),
              );
              this.montarObjLeituraDocumento(data, 'dependente', dependente.id);

              const dependenteComDocumentos = {
                id: dependente.id,
                documentos: data || [],
              };

              this.listaFinalFormulario.dependentes.push(dependenteComDocumentos);

              this.atualizarFormularioDependente(dependente.id, data);
              return {id: dependente.id, documentos: data};
            } catch (err: any) {
              this.toastr.error('Erro inesperado ao buscar documentos dos dependentes.');
              this._errorLoggingService.logError('Erro inesperado ao buscar documentos dos dependentes', err, {
                contexto: 'Buscar documentos dos dependentes',
                proposalId: this.proposalId,
                dependentProposalId,
              });

              var mensagemTratada = err?.message?.replace('Error:', '');
              if (mensagemTratada.includes('[object Object]')) {
                this.toastr.warning('Nenhum documento localizado!');
              } else {
                this.toastr.warning(mensagemTratada || 'Erro ao buscar documentos.');
              }
              return null;
            }
          }),
        );

        // Filtra os resultados válidos e atualiza a lista
        this._listaDocumentosDependente = resultados.filter(r => r !== null);
        return this._listaDocumentosDependente;
      }

      // Caso: buscar um dependente específico
      const data = await lastValueFrom(
        this.documentoPropostaEntidadeService.buscarDocumentoDependentePropostaId(dependentProposalId, this.proposalId),
      );
      this.montarObjLeituraDocumento(data, 'dependente', dependentProposalId);
      this._listaDocumentosDependente = data;
      return data;
    } catch (error) {
      this.toastr.error('Erro inesperado ao buscar documentos dos dependentes.');
      this._errorLoggingService.logError('Erro inesperado ao buscar documentos dos dependentes', error, {
        contexto: 'buscar documentos dos dependentes - buscarTodosOsDependentesDoTitular',
        proposalId: this.proposalId,
        dependentProposalId,
      });

      return [];
    } finally {
      this.pararSpinner();
    }
  }

  //Prepara os dados para tratar o form
  alimentarFormDependente(dependenteIndex: number, dependenteId: string): void {
    this.marcarFormDependenteComoTocado();
    const documentos = this.propostaCompleta[dependenteIndex].documentos;
    this.atualizarFormularioDependente(dependenteId, documentos);
  }

  // Responsável por atualizar o formulário do dependente com os dados obtidos.
  private atualizarFormularioDependente(dependentId: string, documentos: any): void {
    const formGroupIndex = this.formGroupDependentes.findIndex(formGroup => formGroup.value.idLife === dependentId);
    if (formGroupIndex !== -1) {
      this.formGroupDependentes[formGroupIndex].patchValue({
        noteSupport: documentos?.noteSupport,
        neediness: documentos?.neediness,
        otherPendingIssues: documentos?.otherPendingIssues,
      });
    }
  }

  async buscarDocumentosTitular() {
    this.iniciarSpinner();

    try {
      const data = await lastValueFrom(
        this.documentoPropostaEntidadeService.buscarDocumentoPorTitularPropostaId(
          this.holderProposalId,
          this.proposalId,
        ),
      );
      this.montarObjLeituraDocumento(data, 'titular', this.holderProposalId);

      this._listaDocumentosTitular = data || [];

      this.listaFinalFormulario.titular = data && data;
      const dadosTitular = data;

      if (this.heColaborador) {
        if (data.defaultWithAdmServ === null || dadosTitular.defaultWithAdmServ === undefined)
          dadosTitular.defaultWithAdmServ = false;
        this.formGroupTitular && this.formGroupTitular?.patchValue(dadosTitular);
        if (!dadosTitular?.neediness) {
          this.formGroupTitular.get('neediness')?.setValue(null);
          this.formGroupTitular.get('neediness')?.setValidators([Validators.required, Validators.maxLength(250)]);
          this.formGroupTitular.get('neediness')?.updateValueAndValidity();
          this.pendenciaFormTitular = true;
        }
      }
    } catch (error: any) {
      // Opcional: mensagem amigável para o usuário
      this.toastr.error('Erro ao carregar documentos do titular. Tente novamente.');
      // Log de erro padronizado no Sentry
      this._errorLoggingService.logError('Erro ao buscar documentos do titular', error, {
        contexto: 'Buscar documentos do titular - buscarDocumentosTitular',
        holderProposalId: this.holderProposalId,
        proposalId: this.proposalId,
      });
    } finally {
      this.pararSpinner(1000);
    }
  }

  private montarObjLeituraDocumento(data: any, origem?: string, id?: string) {
    const listaExtraData: any[] = [];

    data.documents.forEach((grupo: any) => {
      if (grupo.extraData && grupo.documents) {
        grupo.documents
          .filter((doc: any) => doc !== null)
          .forEach((doc: any) => {
            listaExtraData.push({
              groupTitle: grupo.groupTitle,
              extraData: grupo.extraData,
              documentTitle: doc.title,
              documentType: doc.documentType,
              documentStatus: doc.documentStatus,
            });
          });
      }
    });

    data.documents =
      data?.documents?.map((item: any) => ({
        ...item,
        documents: item.documents?.filter((doc: any) => doc !== null) || [],
      })) || [];

    // Chave única por origem + id
    const chave = `${origem}_${id ?? 'sem-id'}`;
    this.informacoesDocumentoVisualizarMap.set(chave, listaExtraData);
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  // Função para alternar o estado do acordeão
  alternarAcordeao(value: string) {
    if (this.acordeaoEstado[value]) {
      this.acordeaoEstado[value] = false;
      this.acordeaoAtivo = null;
    } else {
      this.acordeaoEstado[value] = true;
      this.acordeaoAtivo = {tipo: 'titular'}; // ← registra titular como ativo
    }
  }

  getDescricaoStatus(status: DocumentStatusEnum): string {
    return descricaoStatusDocumento[status] || 'Status desconhecido';
  }

  abrirModalConfirmar(template: TemplateRef<any>, acao: any, mostrarMotivo: boolean) {
    const descricaoAcao = acao === 4 ? 'DEVOLVER' : 'CONFIRMAR';
    this.tituloAcaoModal = this.getDescricaoStatus(acao);
    this.heDevolucaoDocumento = mostrarMotivo;
    this.mensagemConfirmacao = `Tem certeza que deseja  ${descricaoAcao} este documento?`;
    this.exibirMotivo = mostrarMotivo;
    this.motivoDevolucaoDocumento = '';
    this.statusDocumento = acao;
    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg',
      id: 'modalDuplaConfirmacao',
      backdrop: 'static',
    });
  }

  confirme() {
    if (!this.podeCadastrarEditar) {
      this.toastr.warning('Você não tem permissão para essa ação. Solicite essa permissão para seu supervisor.');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    }
    if (this.exibirMotivo && !this.motivoDevolucaoDocumento.trim()) {
      this.toastr.warning('Por favor, informe o motivo da devolução.');
      return;
    }
    this.colaboradorAtualizaDocumento();
  }

  decline() {
    this.modalRef?.hide();
  }

  colaboradorAtualizaDocumento() {
    try {
      var documentoVM = {
        documentProposalId: this.codigoDocumento,
        documentStatusEnum: this.statusDocumento,
        observation: this.motivoDevolucaoDocumento,
      };
      this.iniciarSpinner();
      this.documentoPropostaEntidadeService
        .atualizarStatusDocumento(documentoVM)
        .pipe(
          finalize(() => {
            this.controlarNavegacaoDosAcordeons();
          }),
        )
        .subscribe({
          next: (retornoDM: any) => {
            this.modalRef?.hide();
            this.toastr.success(retornoDM.message);
            if (this.origem == 'titular') this.buscarDocumentosTitular();
            else this.recarregarDocumentosDependente();
            this.fecharModalVisualizar();
          },

          error: (retornoDM: any) => {
            this.pararSpinner();
            // LOG: registrar erro para Sentry com contexto
            this._errorLoggingService.logError('Erro ao atualizar status do documento', retornoDM, {
              contexto: 'Atualizar status do documento',
              documentProposalId: this.codigoDocumento,
              statusDocumento: this.statusDocumento,
              origem: this.origem,
            });

            this.modalRef?.hide();
            this.fecharModalVisualizar();
            this.toastr.error(retornoDM.message);
          },
        });
    } catch (error) {
      this.pararSpinner();
      this._errorLoggingService.logError('Erro ao atualizar status do documento', error, {
        contexto: 'Atualizar status do documento',
        documentProposalId: this.codigoDocumento,
        statusDocumento: this.statusDocumento,
        origem: this.origem,
      });
    }
  }

  private enviarDadosDocumentosTitularDependentes(
    dadosDocumentoTitularDependenteVM: any[],
    templateModalAlerta?: TemplateRef<any>,
  ) {
    this.toastr.toastrConfig.preventDuplicates = true;
    this.iniciarSpinner();

    this.documentoPropostaEntidadeService
      .cadastrarDadosDocumentos(dadosDocumentoTitularDependenteVM)
      .pipe(
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe({
        next: (retornoDM: any) => {
          this.toastr.success(retornoDM.message);
          this.mensagemModal = retornoDM.message;
          //  this.somenteLeituraStep = true;
          if (this.ehColaborador) {
            this.abrirModalDocumentoEnviado();
            this.mensagemRetornoDocumentoOK = retornoDM;
          } else {
            //é beneficiario e vai para a aba de analise;
            this.stepAtual = PropostaExternaEnum.ANALISE;
            this.onNavegarAbas(PropostaExternaEnum.ANALISE);
          }
        },
        error: (retornoDM: any) => {
          this.pararSpinner();
          let mensagemErro = 'Erro ao enviar documentos';

          try {
            mensagemErro = JSON.parse(retornoDM.message).message || retornoDM.message;
          } catch (e) {
            // Se falhar o parse, usa a mensagem original
            mensagemErro = retornoDM.message || 'Erro ao enviar documentos';
          }

          try {
            if (retornoDM.status == 400) {
              this.listaRetornoEnvio = [];
              this.existeDocumentoComPendencia = [];

              const parsedMessage = JSON.parse(retornoDM.message);
              if (parsedMessage.details && Array.isArray(parsedMessage.details) && parsedMessage.details !== null) {
                this.listaRetornoEnvio = parsedMessage.details;

                if (this.listaRetornoEnvio.length > 0) {
                  this.existeDocumentoComPendencia = this.listaRetornoEnvio;
                }

                if (templateModalAlerta && this.temAlgumaPendencia()) {
                  this.abrirModalPendenciaDocumentos(templateModalAlerta);
                  return;
                }

                this.mensagemListaRetornoDM = parsedMessage.message;
              } else {
                this.toastr.error(parsedMessage.message);
                this.listaRetornoEnvio = [];
                this.existeDocumentoComPendencia = [];
              }
            }
          } catch (error) {
            this.pararSpinner();
          }
          this.toastr.error(this.mensagemListaRetornoDM || 'Erro ao enviar documentos');
          this.toastr.toastrConfig.preventDuplicates = true;

          // Log de erro para facilitar rastreamento no Sentry
          this._errorLoggingService.logError('Erro no envio de dados dos documentos (Titular/Dependentes)', retornoDM, {
            dadosDocumentoTitularDependenteVM,
          });
        },
      });
  }

  // recarregarRota(dados: any) {
  //   const currentUrl = this._router.url;
  //   this._router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
  //     this._router.navigate([currentUrl]);
  //     setTimeout(() => {
  //       this.tratativaRedirecionamentoAbas(dados);
  //     }, 100);
  //   });
  // }

  private tratativaRedirecionamentoAbas(retornoDM?: any) {
    if (this.ehColaborador) {
      this.somenteLeituraStep = true;
    }
    this.stepAtual = retornoDM.step;
    this.goToTop();
    this.pararSpinner();
  }

  onNavegarAbas(aba?: any) {
    if (aba == PropostaExternaEnum.ANALISE) {
      this.tabService.avancarParaProximaAba('analise');
      this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.ANALISE);
      this.tabService.definirStepAtual(this.stepAtual);
    } else if (aba == PropostaExternaEnum.VIDEO_CONFERENCIA) {
      this.tabService.avancarParaProximaAba('videoConferencia');
      this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.VIDEO_CONFERENCIA);
      this.tabService.definirStepAtual(this.stepAtual);
    } else if (aba == PropostaExternaEnum.PAGAMENTO) {
      this.tabService.avancarParaProximaAba('pagamento');
      this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.PAGAMENTO);
      this.tabService.definirStepAtual(this.stepAtual);
    }
  }

  irParaAnalise(acadestino?: number) {
    this.onNavegarAbas(PropostaExternaEnum.ANALISE);
    this.modalService.hide();
  }

  irParaVideoConferencia() {
    this.stepAtual = PropostaExternaEnum.VIDEO_CONFERENCIA;
    this.onNavegarAbas(PropostaExternaEnum.VIDEO_CONFERENCIA);
  }

  irParaPagamento() {
    this.stepAtual = PropostaExternaEnum.PAGAMENTO;
    this.onNavegarAbas(PropostaExternaEnum.PAGAMENTO);
  }

  beneficiarioAvancar(templateModalAlerta: TemplateRef<any>, templateModalExistente: TemplateRef<any>) {
    const dadosBeneficiarioVM = {
      sendColaborator: false,
      proposalId: this.proposalId,
    } as any;
    this.RevisarDocumento();
    if (this.somenteLeituraStep) {
      if (this.inclusaoDependente || !this.heOdonto) {
        this.irParaVideoConferencia();
      } else {
        this.irParaPagamento();
      }
    } else {
      if (this.stepAtual == this.propostaEnum.ANALISE) {
        this.modalRef = this.modalService.show(templateModalExistente, {
          class: 'modal-sm',
        });

        return;
      } else {
        const dadosDocumentoTitularDependenteVM = [dadosBeneficiarioVM];
        this.enviarDadosDocumentosTitularDependentes(dadosDocumentoTitularDependenteVM, templateModalAlerta);
      }
    }
  }

  colaboradorAvancar(templateModalAlerta: TemplateRef<any>) {
    try {
      if (!this.podeCadastrarEditar) {
        this.toastr.warning('Você não tem permissão para essa ação. Solicite essa permissão para seu supervisor.');
        this.toastr.toastrConfig.preventDuplicates = true;
        return;
      }

      this.textoSpinner = 'Verificando dados do Dependente(s)';

      this.isFormSubmitedTitular = true;
      this.isFormSubmitedDependente = true;

      // Marca todos os campos do titular como "tocados"
      this.validarFormTitular();

      // Verificar se há pendências nos formulários dos dependentes
      this.marcarFormDependenteComoTocado();
      if (this.verificarPendenciasFormulariosDependentes()) {
        this.validarFormDependente();
        this.pararSpinner();
        return;
      }

      // Verifica se o formulário do titular é válido
      if (!this.inclusaoDependente && !this.formGroupTitular.valid) {
        this.toastr.warning('Preencha todos os campos obrigatórios do Titular!');
        this.pararSpinner();
        return;
      }

      // Coletar os dados do titular
      this.holderProposalId = this.listaFinalFormulario?.titular?.holderId;

      const dadosFormaularioTitularVM = {
        idLife: this.holderProposalId ?? this.idTitularImutavel,
        holder: true,
        defaultWithAdmServ: this.listaFinalFormulario.titular?.defaultWithAdmServ ?? false,
        neediness: this.listaFinalFormulario.titular?.neediness ?? '',
        otherPendingIssues: this.listaFinalFormulario.titular?.otherPendingIssues ?? false,
        noteSupport: this.listaFinalFormulario.titular?.noteSupport ?? '',
        sendColaborator: this.heColaborador,
        proposalId: this.proposalId,
      };

      const dadosFormDependentesVM = this.listaFinalFormulario.dependentes.map((itemFormulario: any) => {
        return {
          idLife: itemFormulario.id || itemFormulario.documentos?.idLife,
          holder: false,
          neediness: itemFormulario.documentos?.neediness,
          otherPendingIssues: itemFormulario.documentos?.otherPendingIssues ?? false,
          noteSupport: itemFormulario.documentos?.noteSupport || '',
          sendColaborator: this.heColaborador,
          proposalId: this.proposalId,
        };
      });

      const dadosDocumentoTitularDependenteVM = [dadosFormaularioTitularVM, ...dadosFormDependentesVM];

      this.enviarDadosDocumentosTitularDependentes(dadosDocumentoTitularDependenteVM, templateModalAlerta);
    } catch (error) {
      this._errorLoggingService.logError('Erro no envio de dados dos documentos - botão de Avançar', error, {
        contexto: 'colaboradorAvancar',
        propossalId: this.proposalId,
      });
    }
  }

  private validarFormTitular() {
    Object.keys(this.formGroupTitular.controls).forEach(controlName => {
      this.formGroupTitular.get(controlName)?.markAsTouched();
    });
  }

  private marcarFormDependenteComoTocado() {
    this.formGroupDependentes.forEach(formGroup => {
      Object.keys(formGroup.controls).forEach(controlName => {
        formGroup.get(controlName)?.markAsTouched();
      });
    });
  }

  // Método para verificar se há pendências nos formulários dos dependentes
  private verificarPendenciasFormulariosDependentes(): boolean {
    return this.formGroupDependentes.some(formGroup => formGroup.invalid);
  }

  abrirModalPendenciaDocumentos(templateModalAlerta: TemplateRef<any>) {
    this.modalRef = this.modalService.show(templateModalAlerta, {
      class: 'modal-dialog-centered modal-xl',
      backdrop: 'static',
      keyboard: false,
    });
  }

  async imprimir() {
    this.iniciarSpinner();
    try {
      // Espera o DOM estar pronto para captura
      await new Promise(resolve => setTimeout(resolve, 200));

      const element = document.getElementById('section-visualizar');
      if (!element) {
        this.toastr.warning('Seção para visualização não encontrada.');
        return;
      }

      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('l', 'mm', 'a4');
      const margin = 2;
      const imgWidth = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
      pdf.save('cotacao_cliente_' + new Date().toISOString() + '.pdf');
    } catch (error) {
      this.toastr.error('Erro ao gerar o PDF da cotação.');
      this._errorLoggingService.logError('Erro ao gerar PDF da cotação', error, {
        contexto: 'imprimir() ',
      });
    } finally {
      this.pararSpinner();
    }
  }

  async abrirModalAditivo(): Promise<void> {
    if (this.modalAberto) {
      return;
    }

    try {
      this.iniciarSpinner();

      const modaisParaMostrar = this.obterModaisNaoAssinados();

      if (modaisParaMostrar.length === 0) {
        return;
      }

      this.modalAberto = true;

      // Mostra os modais sequencialmente
      for (const modal of modaisParaMostrar) {
        await this.mostrarModalIndividual(modal);
      }
    } catch (erro) {
      this._errorLoggingService.logError('Erro ao abrir modal aditivo', erro, {
        contexto: 'Cadastro de proposta Interna',
        dadosEnviados: {
          listaDeBeneficiarios: this.listaDeBeneficiarios,
        },
      });
    } finally {
      this.modalAberto = false;
      this.pararSpinner();
    }
  }

  /**
   * Obtém lista de modais que ainda não foram assinados.
   * Retorna beneficiários ordenados (titular primeiro) que precisam assinar.
   */
  private obterModaisNaoAssinados(): Array<{type: number; nome: string; id: string}> {
    // Ordena: titular primeiro, depois dependentes
    const beneficiariosOrdenados = [...this.listaDeBeneficiarios].sort((a, b) =>
      a.isDependent === b.isDependent ? 0 : a.isDependent ? 1 : -1,
    );

    // Filtra apenas os que precisam assinar aditivo
    return beneficiariosOrdenados
      .filter(beneficiario => this.precisaAssinarAditivo(beneficiario))
      .map(beneficiario => ({
        type: beneficiario.proposalType,
        nome: beneficiario.name,
        id: beneficiario.id,
      }));
  }

  /**
   * Verifica se o beneficiário precisa assinar termo aditivo.
   * @param beneficiario - Dados do beneficiário
   * @returns true se precisa assinar, false se já assinou
   */
  private precisaAssinarAditivo(beneficiario: any): boolean {
    const ehPortabilidade = beneficiario.proposalType === TipoPropostaEnum.PORTABILIDADE;
    const ehSumula = beneficiario.proposalType === TipoPropostaEnum.SUMULA;

    if (!ehPortabilidade && !ehSumula) {
      return false;
    }

    // Verifica se JÁ assinou o aditivo
    const jaAssinouAditivo = this.verificaAssinatura(beneficiario, TipoModalAssinaturaEnum.ADITIVO);

    // Retorna true se NÃO assinou (precisa assinar)
    return !jaAssinouAditivo;
  }

  private verificaAssinatura(beneficiario: any, tipoModal: TipoModalAssinaturaEnum): boolean {
    // Se não tem assinaturas, retorna false
    if (!beneficiario.additiveSignatures || !Array.isArray(beneficiario.additiveSignatures)) {
      return false;
    }

    // Se o array está vazio, retorna false
    if (beneficiario.additiveSignatures.length === 0) {
      return false;
    }

    // Verifica se existe alguma assinatura com o modalType correto
    const temAssinatura = beneficiario.additiveSignatures.some((assinatura: any) => {
      // Converte para number para garantir comparação correta
      const modalTypeAssinatura = Number(assinatura.modalType);
      const modalTypeBuscado = Number(tipoModal);

      return modalTypeAssinatura === modalTypeBuscado;
    });

    return temAssinatura;
  }

  private async mostrarModalIndividual(modal: any): Promise<void> {
    return new Promise<void>(resolve => {
      this.nomeModalAditivo = modal.nome;
      this.mostrarModalAditivo = modal.type;
      this.idBeneficiarioDoModalAditivo = modal.id;
      this.checkboxModalAditivo = false;

      const modalRef = this.modalService.show(this.modalAditivo, {
        backdrop: 'static',
        class: 'modal-xl',
        id: `modal-${modal.type}-${modal.id}`,
      });

      modalRef.onHidden?.subscribe(() => {
        this.pararSpinner();
        resolve();
      });
    });
  }

  separarBeneficiarios(dados: any) {
    const beneficiario = dados && dados.holderProposal;

    if (beneficiario) {
      const dadosTitular = {...beneficiario};
      delete dadosTitular.dependentsProposal;

      this.listaDeBeneficiarios &&
        this.listaDeBeneficiarios.push({
          ...dadosTitular,
          isDependent: false,
          proposalType: dados.proposalType,
        });

      if (beneficiario.dependentsProposal && Array.isArray(beneficiario.dependentsProposal)) {
        beneficiario.dependentsProposal &&
          beneficiario.dependentsProposal?.forEach((dependente: any) => {
            const itemDependente = {
              ...dependente,
              isDependent: true,
            };
            this.listaDeBeneficiarios && this.listaDeBeneficiarios.push(itemDependente);
          });
      }
    }
  }

  //  Aumenta o zoom em 10%.
  aumentarZoom() {
    this.zoom += 0.1;
  }
  // Diminui o zoom em 10%, com limite mínimo de 20%.
  diminuirZoom() {
    if (this.zoom > 0.2) this.zoom -= 0.1;
  }
  //  Gira a imagem ou PDF 90° para a esquerda.
  girarEsquerda() {
    this.rotation = (this.rotation - 90 + 360) % 360;
  }
  //Gira a imagem ou PDF 90° para a direita.
  girarImagemDireita() {
    this.rotation = (this.rotation + 90) % 360;
  }

  resetarVisualizacao() {
    this.zoom = 0.8;
    this.rotation = 0;
  }

  calcImgWidth(): number {
    if (this.rotation % 180 === 0) {
      return this.naturalWidth * this.zoom;
    } else {
      return this.naturalHeight * this.zoom;
    }
  }

  onImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    this.naturalWidth = img.naturalWidth;
    this.naturalHeight = img.naturalHeight;
  }
  // baixarDocumento(
  //   event: MouseEvent,
  //   tipo: 'imagem' | 'pdf',
  //   nomeArquivo?: string,
  // ) {

  //   if (nomeArquivo === undefined || nomeArquivo === null)
  //     nomeArquivo = 'documento';
  //   event.stopPropagation();
  //   const link = document.createElement('a');
  //   link.href = this.visualizarArquivoUrl;
  //   link.download =
  //     tipo === 'imagem' ? nomeArquivo + '.jpg' : nomeArquivo + '.pdf';
  //   link.target = '_blank';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }

  async assinarTermoAditivo(idBeneficiario: string): Promise<any> {
    try {
      this.iniciarSpinner();
      // Encontrar o beneficiário específico na lista
      const beneficiario = this.listaDeBeneficiarios.find((b: any) => b.id === idBeneficiario);

      if (!beneficiario) {
        this.toastr.error('Beneficiário não encontrado');
        return false;
      }

      this.objModalAditivo = {
        proposalId: this.proposalId,
        proposalType: this.mostrarModalAditivo || beneficiario.proposalType,
        modalType: TipoModalAssinaturaEnum.ADITIVO,
      };

      if (!beneficiario.isDependent) {
        this.objModalAditivo.holderProposalId = beneficiario.id;
      } else {
        this.objModalAditivo.dependentProposalId = beneficiario.id;
      }
      // Fazer a requisição para assinar o modal
      await lastValueFrom(this._beneficiarioProposaService.assinarModaisAditivos(this.objModalAditivo));
      this.toastr.success(
        `Termo de Aditivo de ${this.getDescricaoTipoProposta(this.mostrarModalAditivo)} assinado com sucesso.`,
      );
      this.toastr.toastrConfig.preventDuplicates = true;
      this.modalService.hide();

      return true;
    } catch (error) {
      this.toastr.error(
        `Erro ao assinar o aditivo de ${this.getDescricaoTipoProposta(this.mostrarModalAditivo)} da proposta externa.`,
      );
      this.toastr.toastrConfig.preventDuplicates = true;
      this._errorLoggingService.logError('Erro ao assinar o aditivo da proposta externa', error, {
        contexto: 'Falha para assinar o modal de aditivo da proposta externa na aba de documentos.',
        dadosEnviados: {
          ObjetoEnviado: this.objModalAditivo,
        },
      });
      return false;
    } finally {
      this.pararSpinner();
    }
  }

  getDescricaoTipoProposta(tipoProposta: any): String {
    return TipoPropostaEnumDescription.getDescricao(tipoProposta);
  }

  public get ehColaborador(): boolean {
    return this._router.url.includes('colaborador');
  }

  abrirModalDocumentoEnviado() {
    this.modalConfirmacaoDocumentacaoEnviadaRef = this.modalService.show(this.modalConfirmacaoDocumentacaoEnviada, {
      backdrop: 'static',
      class: 'modal-md',
      id: 'modalConfirmacaoDocumentacaoEnviada',
    });
  }

  validarCampoObservacao(value: any) {
    if (!value) {
      this.formGroupTitular.get('noteSupport')?.setValue(null);
      this.formGroupTitular.get('noteSupport')?.clearValidators();
    } else {
      this.formGroupTitular.get('noteSupport')?.setValidators([Validators.required, Validators.maxLength(250)]);
    }
    this.formGroupTitular.get('noteSupport')?.updateValueAndValidity();
  }

  validarCampoObservacaoDependente(value: any, index: any, dependenteNome?: any) {
    //se false

    if (!value) {
      this.formGroupDependentes[index].get('noteSupport')?.setValue(null); //limpar campo obeservacao
      this.formGroupDependentes[index].get('noteSupport')?.clearValidators();

      //se nullo
      const inptuCarencia = this.formGroupDependentes[index].controls['neediness'].value;
      if (!inptuCarencia) {
        this.marcarPendenciaFormDependente(dependenteNome);
      } else {
        this.pendenciasPorDependente.delete(dependenteNome.toLowerCase());
      }
    } else {
      this.formGroupDependentes[index]
        .get('noteSupport')
        ?.setValidators([Validators.required, Validators.maxLength(250)]);
      // Verificar se o campo noteSupport está vazio quando checkbox marcado
      const noteSupportValue = this.formGroupDependentes[index].get('noteSupport')?.value;
      if (!noteSupportValue) {
        this.isFormSubmitedDependente = true;
        this.marcarPendenciaFormDependente(dependenteNome);
      } else {
        this.pendenciasPorDependente.delete(dependenteNome.toLowerCase());
      }
    }
    this.formGroupDependentes[index].get('noteSupport')?.updateValueAndValidity();
    this.cdRef.detectChanges();
    this.cdRef.markForCheck();
  }

  atualizaFormularioTitular() {
    this.listaFinalFormulario.titular = this.formGroupTitular.value;
  }

  atualizaFormularioDependente(index: number) {
    const observacao = this.formGroupDependentes[index].controls['noteSupport'].value;
    const possuiDemaisPendencia = this.formGroupDependentes[index].controls['otherPendingIssues'].value;
    const carencia = this.formGroupDependentes[index].controls['neediness'].value;
    const nomeDependente = this.formGroupDependentes[index].controls['dependenteName'].value;

    // 1. Se otherPendingIssues == true existe pendência e o campo obsevacao for nullo

    if (possuiDemaisPendencia === true && !observacao) {
      this.marcarPendenciaFormDependente(nomeDependente);
    }
    // 2. Se neediness for null existe pendência
    else if (!carencia) {
      this.marcarPendenciaFormDependente(nomeDependente);
    }
    // 3. Caso contrário deletar pendência
    else {
      this.pendenciasPorDependente.delete(nomeDependente.toLowerCase());
    }

    this.listaFinalFormulario.dependentes[index] = {
      ...this.listaFinalFormulario.dependentes[index],
      documentos: {} as any,
    };

    this.listaFinalFormulario.dependentes[index].documentos = this.formGroupDependentes[index].value as any;
    this.cdRef.detectChanges();
    this.cdRef.markForCheck();
  }

  preencherDados(titular: boolean, index: number) {
    if (titular) {
      const dadosTitular = this.listaFinalFormulario.titular || {};
      // Garante que defaultWithAdmServ tenha um valor padrão se for null
      if (dadosTitular.defaultWithAdmServ === null || dadosTitular.defaultWithAdmServ === undefined) {
        dadosTitular.defaultWithAdmServ = false;
      }
      this.formGroupTitular && this.formGroupTitular?.patchValue(dadosTitular);
    } else {
      let documentos = this.listaFinalFormulario && this.listaFinalFormulario?.dependentes[index]?.documentos;
      this.formDependenteAlterado = true;
      this.formGroupDependentes[index].patchValue(documentos);
    }
  }

  goToTop() {
    setTimeout(() => {
      this._scrollService.scrollToElement(`#propostaExterna`, 140);
      this._scrollService.setStyle(`#propostaExterna`, {
        'margin-top': '-141px !important',
      });
    }, 100);
  }

  abrirModalFormularioInscricaoEntidade() {
    this.modalInscricaoEntidadeRef = this.modalService.show(this.modalFormularioInscricaoEntidade, {
      backdrop: 'static',
      class: 'modal-xl',
      id: 'inscricaoEntidade',
    });
  }

  async buscarDadosPropostaEntidadeFormulario() {
    if (this.nomeEntidade.trim().toUpperCase() === 'ADSERVIP') {
      this.buscarDadosPropostaEntidadeFormularioAdservip();
    } else if (this.nomeEntidade.trim().toUpperCase() === 'ABJE') {
      this.buscarDadosPropostaEntidadeFormularioAbje();
    }
  }

  fecharModalInscricao() {
    this.modalInscricaoEntidadeRef?.hide();
  }

  get podeABrirModalFormularioInscricao(): boolean {
    return (
      (this.nomeEntidade?.trim().toUpperCase() === 'ADSERVIP' || this.nomeEntidade?.trim().toUpperCase() === 'ABJE') &&
      //  this.linkExternoEntidade === false &&
      this.heAssociado === false &&
      this.ehColaborador === true &&
      this.inclusaoDependente === false
    );
  }

  carregarDadosOperadora(): string {
    const cnpjOperadoraFiltro = this.dadosOperadoraCabecalho?.cnpjOperadora;

    if (!cnpjOperadoraFiltro) {
      return '';
    }
    // Busca os dados da operadora pelo CNPJ
    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(cnpjOperadoraFiltro);

    // Retorna o logo dos dados ou um padrão
    return dadosOperadora;
  }

  preencherAssinaturas(dados: any) {
    let listaStepsAssinados = dados;
    const assinaturaFormInscricao = listaStepsAssinados.find(
      (item: any) => item.step === PropostaExternaEnum.BENEFICIARIO_ENDERECO,
    );

    if (assinaturaFormInscricao) {
      const dataAssinatura = FormatarUtil.assinatura(assinaturaFormInscricao.createDate);
      this.dataAssinaturaFormInscricao = dataAssinatura.data;
      this.horaAssinaturaFormInscricao = dataAssinatura.hora;
    }
  }

  fecharModalPendenciaDocumentos() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  beneficiarioChecarPendencia(nome: string, tipo: 'Titular' | 'Dependente' = 'Dependente'): boolean {
    if (!nome) return false;
    if (this.ehColaborador) return false;
    // Verifica na listaRetornoEnvio
    let temPendenciaRetorno =
      this.listaRetornoEnvio?.length > 0 &&
      this.listaRetornoEnvio.some(pendencia => {
        // Verifica se o tipo (Titular/Dependente) e o nome correspondem
        if (
          pendencia.beneficiaryType?.toLowerCase() === tipo.toLowerCase() &&
          pendencia.name?.toLowerCase() === nome.toLowerCase()
        ) {
          return pendencia.pendingDocumentsCount > 0 || pendencia.correctionDocumentsCount > 0;
        }
        return false;
      });

    // Verifica na existeDocumentoComPendencia
    const temPendenciaInicial =
      this.existeDocumentoComPendencia?.length > 0 &&
      this.existeDocumentoComPendencia.some(pendencia => {
        // Verifica se o tipo (Titular/Dependente) e o nome correspondem
        if (
          pendencia.beneficiaryType?.toLowerCase() === tipo.toLowerCase() &&
          pendencia.name?.toLowerCase() === nome.toLowerCase()
        ) {
          // Retorna true se houver documentos pendentes ou que precisam de correção
          return pendencia.pendingDocumentsCount > 0 || pendencia.correctionDocumentsCount > 0;
        }
        return false;
      });

    // Retorna true se encontrar pendência em qualquer uma das listas
    return temPendenciaRetorno || temPendenciaInicial;
  }

  //Versao futura, pedir ao marcelo para criar um end point especifo para trazer todos os documentos que tem statsu igual a enviado.
  colaboradorChecarPendencia(nome: string, tipo: 'Titular' | 'Dependente' = 'Dependente'): boolean {
    if (!this.ehColaborador) return false;
    if (!nome) return false;

    // Verifica se há pendência de formulário para este dependente específico
    if (tipo === 'Dependente' && this.pendenciasPorDependente.get(nome.toLowerCase())) {
      return true;
    }

    // Verifica se há pendência de formulário do titular
    if (tipo === 'Titular' && this.pendenciaFormTitular) {
      return true;
    }

    // Verifica na listaRetornoEnvio apenas sentingDocumentsCount
    const temPendenciaRetorno =
      this.listaRetornoEnvio?.length > 0 &&
      this.listaRetornoEnvio.some(pendencia => {
        if (
          pendencia.beneficiaryType?.toLowerCase() === tipo.toLowerCase() &&
          pendencia.name?.toLowerCase() === nome.toLowerCase()
        ) {
          // Para colaborador, verifica apenas sentingDocumentsCount
          return pendencia.sentingDocumentsCount > 0;
        }
        return false;
      });

    // Verifica na existeDocumentoComPendencia apenas sentingDocumentsCount
    const temPendenciaInicial =
      this.existeDocumentoComPendencia?.length > 0 &&
      this.existeDocumentoComPendencia.some(pendencia => {
        if (
          pendencia.beneficiaryType?.toLowerCase() === tipo.toLowerCase() &&
          pendencia.name?.toLowerCase() === nome.toLowerCase()
        ) {
          // Para colaborador, verifica apenas sentingDocumentsCount
          return pendencia.sentingDocumentsCount > 0;
        }
        return false;
      });

    // Retorna true se encontrar pendência em qualquer uma das listas
    return temPendenciaRetorno || temPendenciaInicial;
  }

  verificarPendenciaPorPerfil(nome: string, tipo: 'Titular' | 'Dependente'): boolean {
    return this.heColaborador
      ? this.colaboradorChecarPendencia(nome, tipo)
      : this.beneficiarioChecarPendencia(nome, tipo);
  }
  // Método para marcar pendência de formulário para um dependente específico
  marcarPendenciaFormDependente(nomeDependente: string): void {
    this.pendenciasPorDependente.set(nomeDependente.toLowerCase(), true);
  }

  // Método para marcar pendência de formulário do titular
  marcarPendenciaFormTitular(): void {
    this.pendenciaFormTitular = true;
  }

  // Método para verificar se existe alguma pendência (titular ou dependentes)
  temAlgumaPendencia(): boolean {
    if (this.heColaborador) {
      const pendenciaColaborador =
        //apenas docuemnts com status enviado.
        this.listaRetornoEnvio?.length > 0 &&
        this.listaRetornoEnvio.some(pendencia => pendencia.sentingDocumentsCount > 0);
      return pendenciaColaborador;
    } else {
      // Verifica na listaRetornoEnvio
      const temPendenciaRetorno =
        this.listaRetornoEnvio?.length > 0 &&
        this.listaRetornoEnvio.some(
          pendencia => pendencia.pendingDocumentsCount > 0 || pendencia.correctionDocumentsCount > 0,
        );

      // Verifica na existeDocumentoComPendencia
      const temPendenciaInicial =
        this.existeDocumentoComPendencia?.length > 0 &&
        this.existeDocumentoComPendencia.some(
          pendencia => pendencia.pendingDocumentsCount > 0 || pendencia.correctionDocumentsCount > 0,
        );
      return temPendenciaRetorno || temPendenciaInicial;
    }
  }

  async verificarStatusDocumentosPorProposta() {
    this.iniciarSpinner();
    this.dadosCarregados = false;
    this.documentoPropostaEntidadeService
      .verificarStatusDocumentosPorProposta(this.proposalId)
      .pipe(
        finalize(() => {
          (this.pararSpinner(), (this.dadosCarregados = true));
        }),
      )
      .subscribe({
        next: (data: any) => {
          if (!data) {
            this.listaRetornoEnvio = [];
            this.existeDocumentoComPendencia = [];
          }
        },
        error: error => {
          if (error.status == 400) {
            const parsedMessage = JSON.parse(error.message);
            if (parsedMessage.details && Array.isArray(parsedMessage.details) && parsedMessage.details !== null) {
              this.existeDocumentoComPendencia = parsedMessage.details;
              this.listaRetornoEnvio = parsedMessage.details;
            } else {
              this.listaRetornoEnvio = [];
              this.existeDocumentoComPendencia = [];
            }
          }
        },
      });
  }

  async buscarDadosPropostaEntidadeFormularioAdservip() {
    this.iniciarSpinner();
    this.retornoDadosFormularioEntidade = null;

    this._entidadeService
      .buscarRegsitroEntidadePorPropostaAdservip(this.proposalId)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          if (data) {
            this.abrirModalFormularioInscricaoEntidade();
            this.retornoDadosFormularioEntidade = data;
            this.existeFormularioEntidade = true;
          }
        },
        error: error => {
          if (error.status == 404) {
            this.toastr.info('Nenhum formulário encontrado!');
            this.existeFormularioEntidade = false;
          }

          this.pararSpinner();
        },
      });
  }

  async buscarDadosPropostaEntidadeFormularioAbje() {
    this.iniciarSpinner();
    this.retornoDadosFormularioEntidade = null;
    this._entidadeService
      .buscarRegsitroEntidadePorPropostaAbje(this.proposalId)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          if (data) {
            this.abrirModalFormularioInscricaoEntidade();
            this.retornoDadosFormularioEntidade = data;
            this.existeFormularioEntidade = true;
          }
        },
        error: error => {
          if (error.status == 404) {
            this.toastr.info('Nenhum formulário encontrado!');
            this.existeFormularioEntidade = false;
          }

          this.pararSpinner();
        },
      });
  }

  get podeCadastrarEditar() {
    return this.moduloPermissoesService.permissaoCadastrarEditar(
      Modulo.CADASTROS,
      SubModuloNome.PROPOSTA_ELEGIBILIDADE,
    );
  }
  get podeEnviarDocumentosBeneficiario() {
    return this.moduloPermissoesService.permissaoCadastrarEditar(
      Modulo.CADASTROS,
      SubModuloNome.PROPOSTA_DOCUMENTO_INTERNO,
    );
  }

  mostrarModalRevisarOuAvancar() {
    this.modalRevisarDocumentoRef = this.modalService.show(this.ModalConfirmacaoComponentRevisarDocumento, {
      class: 'modal-dialog-centered modal-sm',
      backdrop: 'static',
      keyboard: false,
    });
  }
  fecharModalRevisarOuAvancar() {
    if (this.modalRevisarDocumentoRef) {
      this.modalRevisarDocumentoRef.hide();
    }
  }
  RevisarDocumento() {
    this.fecharModalRevisarOuAvancar();
  }

  podeMostrarBotaoAcaoPorPerfil(): boolean {
    if (this.ehCorretor) {
      // Proposta interna - colaborador e corretor
      return this.podeEnviarDocumentosBeneficiario && this.stepAtual <= this.propostaEnum.RETORNO_DOCUMENTO;
    } else {
      // Proposta externa
      return (
        this.stepAtual <= this.propostaEnum.DOCUMENTO ||
        this.stepAtual == this.propostaEnum.RETORNO_DOCUMENTO ||
        (this.stepAtual == this.propostaEnum.ANALISE && this.ehColaborador)
      );
    }
  }

  //─────────────────────INICIO TRATAMENTO ACORDEON───────────────────────────────────────────────────────
  /*
o fluxo será:
Resolve pendência do titular
Sistema abre automaticamente o dependente 0 (se tiver pendência)
Resolve dependente 0
Sistema abre automaticamente o dependente 1 (se tiver pendência)
E assim por diante até não haver mais pendências

*/
  mensagemSucesso(isEdicao: boolean) {
    this.fecharModal();
    const mensagem = isEdicao ? 'Documento atualizado com sucesso!' : 'Documento cadastrado com sucesso!';
    this.toastr.success(mensagem);
    this.controlarNavegacaoDosAcordeons();
  }

  private controlarNavegacaoDosAcordeons() {
    this.limparCache();
    //   Só fecha se vai mudar de pessoa
    const aindaTemPendenciaNoAtivo = this.verificarPendenciaNoAtivo();
    if (!aindaTemPendenciaNoAtivo) {
      this.forcarFechamentoAcordeao();
    }
    this.atualizarDadosENavegar();
  }

  limparCache() {
    if (window.caches) {
      // Limpa todo o cache
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
  }

  forcarFechamentoAcordeao(): void {
    this.acordeaoEstado = {};
    $('#collapseTitular').collapse('hide');

    const totalDependentes = this.propostaCompleta?.length ?? 0;
    for (let i = 0; i < totalDependentes; i++) {
      $(`#colapseDependente${i}`).collapse('hide');
    }
  }

  private atualizarDadosENavegar(): void {
    this.documentoPropostaEntidadeService
      .verificarStatusDocumentosPorProposta(this.proposalId)
      .pipe(
        finalize(() => {
          this.navegarParaProximaPessoaComPendencia();
        }),
      )
      .subscribe({
        next: (data: any) => {
          if (!data) {
            this.listaRetornoEnvio = [];
            this.existeDocumentoComPendencia = [];
          }
        },
        error: (error: any) => {
          if (error.status === 400) {
            const parsedMessage = JSON.parse(error.message);
            if (parsedMessage.details && Array.isArray(parsedMessage.details)) {
              this.existeDocumentoComPendencia = parsedMessage.details;
              this.listaRetornoEnvio = parsedMessage.details;
            }
          }
        },
      });
  }

  navegarParaProximaPessoaComPendencia(): void {
    const primeiroComPendencia = this.encontrarPrimeiroPendente();

    // setTimeout(() => {
    if (!primeiroComPendencia) {
      this.exibirMensagemSemPendencias();
      this.pararSpinner();
      return;
    }
    // Se é o mesmo que já está aberto — não anima, só para o spinner
    const mesmoAtivo =
      this.acordeaoAtivo?.tipo === primeiroComPendencia.tipo &&
      this.acordeaoAtivo?.index === primeiroComPendencia.index;

    if (mesmoAtivo) {
      this.pararSpinner();
      return;
    }

    // ← Mudou de pessoa — abre o próximo
    if (primeiroComPendencia.tipo === 'titular') {
      this.abrirAcordeaoTitular();
    } else {
      this.abrirAcordeaoDependente(primeiroComPendencia.index!, primeiroComPendencia.dependente);
    }
    // }, 350);
  }

  // ─── Verifica o ativo primeiro, depois segue a ordem normal ──────────────────
  private encontrarPrimeiroPendente(): {tipo: 'titular' | 'dependente'; index?: number; dependente?: any} | null {
    if (this.acordeaoAtivo) {
      if (this.acordeaoAtivo.tipo === 'titular') {
        const aindaTemPendencia = this.verificarPendenciaPorPerfil(this._listaDocumentosTitular?.name, 'Titular');

        if (aindaTemPendencia) return {tipo: 'titular'};
      } else if (this.acordeaoAtivo.tipo === 'dependente') {
        const aindaTemPendencia = this.verificarPendenciaPorPerfil(this.acordeaoAtivo.dependente?.name, 'Dependente');
        if (aindaTemPendencia)
          return {
            tipo: 'dependente',
            index: this.acordeaoAtivo.index,
            dependente: this.acordeaoAtivo.dependente,
          };
      }
    }

    // fallback
    if (!this.inclusaoDependente) {
      const titularPendente = this.verificarPendenciaPorPerfil(this._listaDocumentosTitular?.name, 'Titular');

      if (titularPendente) return {tipo: 'titular'};
    }

    const dependentes = this.propostaCompleta ?? [];
    for (let i = 0; i < dependentes.length; i++) {
      const pendente = this.verificarPendenciaPorPerfil(dependentes[i]?.name, 'Dependente');

      if (pendente) return {tipo: 'dependente', index: i, dependente: dependentes[i]};
    }

    return null;
  }

  private abrirAcordeaoTitular(): void {
    this.acordeaoAtivo = {tipo: 'titular'}; // ← registra quem está aberto
    this.alternarAcordeao(this._listaDocumentosTitular?.holderId);
    $('#collapseTitular').collapse('show');
    setTimeout(() => {
      document.querySelector<HTMLElement>('#headingOne')?.scrollIntoView({behavior: 'smooth', block: 'start'});
      this.pararSpinner();
    }, 350);
  }

  private abrirAcordeaoDependente(index: number, dependente: any): void {
    this.acordeaoAtivo = {tipo: 'dependente', index, dependente}; // ← registra quem está aberto

    const targetId = `#colapseDependente${index}`;
    this.abrirDetalhesDependente(dependente);
    this.preencherDados(false, index);
    $(targetId).collapse('show');

    setTimeout(() => {
      document.querySelector<HTMLElement>(targetId)?.scrollIntoView({behavior: 'smooth', block: 'start'});
      this.pararSpinner();
    }, 350);
  }
  private verificarPendenciaNoAtivo(): boolean {
    if (!this.acordeaoAtivo) return false;

    if (this.acordeaoAtivo.tipo === 'titular') {
      return this.verificarPendenciaPorPerfil(this._listaDocumentosTitular?.name, 'Titular');
    }

    return this.verificarPendenciaPorPerfil(this.acordeaoAtivo.dependente?.name, 'Dependente');
  }
  private exibirMensagemSemPendencias(): void {
    this.forcarFechamentoAcordeao();
    // /aguardar status da tati, coso decida que se no tiver pendencia o sistema segue par a proxima etapa
    // this.toastr.success('Não existem mais pendências!', 'Tudo certo!');
    // if (!this.ehCorretor && !this.heColaborador) {
    //   this.beneficiarioAvancar(null as any, null as any);
    // }
  }
  // ────────────────────────────FIM TRATAMENTO ACORDEON─────────────────────────────────────────────────
  receberDeclinio(stepDeclinado: number) {
    this.stepAtual = stepDeclinado || this.propostaEnum.PROPOSTA_DECLINADA;
  }

  podeMostrarBotaoAcaoValidarDocumento(): boolean {
    if (this.heColaborador) {
      return this.visualizarArquivoUrl && this.podeCadastrarEditar && this.stepAtual === this.propostaEnum.ANALISE;
    }
    return false;
  }

  scrollLeft(element: HTMLElement): void {
    element.scrollBy({left: -200, behavior: 'smooth'});
  }

  scrollRight(element: HTMLElement): void {
    element.scrollBy({left: 200, behavior: 'smooth'});
  }

  processarDocumentos(data: any): DocumentoProcessado[] {
    const documentos: DocumentoProcessado[] = [];
    // Processar documentos do HOLDER - titular
    if (data.holder && data.holder.documents) {
      data.holder.documents.forEach((grupo: any) => {
        grupo.documents.forEach((doc: any) => {
          documentos.push({
            nome: data?.holder?.name,
            tipo: 'Titular',
            grupoDocumento: grupo?.groupTitle,
            tituloDocumento: doc?.title,
            situacao: doc?.status,
            observacao: doc?.observation || '',
            dataUrl: doc?.dataUrl,
            holderId: data?.holder?.holderId,
            tipoDocumento: 0,
          });
        });
      });
    }

    // Processar documentos dos DEPENDENTES
    if (data.dependents && data.dependents.length > 0) {
      data.dependents.forEach((dependente: any) => {
        if (dependente.documents && dependente.documents.length > 0) {
          dependente.documents.forEach((grupo: any) => {
            grupo.documents.forEach((doc: any) => {
              documentos.push({
                nome: dependente.name,
                tipo: 'Dependente',
                grupoDocumento: grupo.groupTitle,
                tituloDocumento: doc.title,
                situacao: doc.status,
                observacao: doc.observation || '',
                dataUrl: doc.dataUrl,
                dependentId: dependente.dependendentId,
                holderId: data.holder.holderId,
                tipoDocumento: dependente.documentType,
              });
            });
          });
        }
      });
    }
    return documentos;
  }

  // Método para obter documentos devolvidos
  visualizarArquivoDevolvidos(modalContentVisualizarArquivosDevolvido: TemplateRef<any>) {
    this.iniciarSpinner();
    this.documentoPropostaEntidadeService
      .buscarDocumentosRepravados(this.proposalId)
      .pipe(
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe({
        next: (data: any) => {
          this.listaDocuemntosProcessadosReprovados = this.processarDocumentos(data);

          this.modalRef = this.modalService.show(modalContentVisualizarArquivosDevolvido, {
            class: 'modal-xl',
            id: 'arquivosDevolvidos',
          });
        },
        error: (error: any) => {
          this.toastr.error('Erro ao buscar documentos devolvidos');
          console.error('Erro:', error);
        },
      });
  }
  baixarDocumento(doc: DocumentoProcessado) {
    if (doc.dataUrl) {
      window.open(doc.dataUrl, '_blank');
    } else {
      this.toastr.warning('Documento não possui visualização disponível');
    }
  }

  enviarOuAprovarDocumento(
    templateModalVisualizarDocumento: TemplateRef<any>,
    templateModalUpload: TemplateRef<any>,
    filePath?: any,
    codigoDocumento?: any,
    origem?: string,
    idOrigem?: any,
    statusDocumento?: any,
    documentoDM?: any,
    tipoDocumento?: any,
    descricaoDocumento?: any,
    documentProposalId?: any,
    documentoGrupo?: any,
    dataUrl?: any,
    motivoReprovacao?: any,
  ) {
    if (statusDocumento === DocumentStatusEnum.PENDENTE && this.heColaborador) {
      this.abrirModal(
        templateModalUpload,
        tipoDocumento,
        origem,
        descricaoDocumento,
        documentProposalId,
        filePath,
        documentoGrupo,
        idOrigem,
        dataUrl,
        motivoReprovacao,
        statusDocumento,
      );
    } else {
      this.abrirModalVisualizarDocumento(
        templateModalVisualizarDocumento,
        filePath,
        codigoDocumento,
        origem,
        idOrigem,
        statusDocumento,
        documentoDM,
        true,
        tipoDocumento,
        documentoGrupo,
      );
    }
  }

  avancarProximoStep() {
    this.stepAtual = PropostaExternaEnum.ANALISE;
    this.iniciarSpinner();
    this._beneficiarioProposaService
      .atualizarStep(this.proposalId, this.stepAtual)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: () => {
          this.toastr.success('Proposta avançada para análise com sucesso!');
          this.toastr.toastrConfig.preventDuplicates = true;
          this.verificarStatusDocumentosPorProposta();
        },
      });
  }
}
